import React from 'react';
import { Link, NavLink, Outlet, Route } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { SignOutButton, useAuth } from '../Auth/AuthProvider';
import { useTheme } from '../Context/ThemeContext';
import { PlatformProvider } from './shared';
import { Dashboard, TenantList, CreateTenant, TenantBoundary, TenantDetail } from './Tenants';
import { Authentication, Subscription, Sso, TenantAdminTransfer } from './TenantSettings';
import { ReactComponent as ListIcon } from '../Icons/notepad.svg';
import { ReactComponent as TenantsIcon } from '../Icons/shape-folder-open.svg';
import '../TenantAdmin/TenantAdmin.css';
import './PlatformAdmin.css';
import AnalyticsDashboard from '../Analytics/AnalyticsDashboard';
import AuditPage from '../Audit/AuditPage';

export default function PlatformShell() {
  const { user } = useAuth(); const { theme, toggleTheme } = useTheme();
  return <PlatformProvider><div className="platform-admin-shell">
    <header className="pa-header"><Link to="/platform-admin">Cobygo · Platform Admin</Link><div>
      <span>{user.email}</span><button className="auth-link-button" onClick={toggleTheme}>Use {theme === 'dark' ? 'light' : 'dark'} theme</button><SignOutButton />
    </div></header>
    <div className="pa-body"><aside className="ta-navigation"><p className="ta-nav-title">Platform operations</p>
      <Nav as="nav" aria-label="Platform administration">
        <Nav.Link as={NavLink} end to="/platform-admin"><ListIcon aria-hidden="true" />Dashboard</Nav.Link>
        <Nav.Link as={NavLink} to="/platform-admin/audit"><ListIcon aria-hidden="true" />Audit</Nav.Link>
        <Nav.Link as={NavLink} end to="/platform-admin/tenants"><TenantsIcon aria-hidden="true" />Tenants</Nav.Link>
        <Nav.Link as={NavLink} to="/platform-admin/tenants/new"><TenantsIcon aria-hidden="true" />Create tenant</Nav.Link>
      </Nav>
    </aside><main className="pa-main"><Outlet /></main></div>
  </div></PlatformProvider>;
}
export function platformAdminRoutes() {
  return <Route path="/platform-admin" element={<PlatformShell />}>
    <Route index element={<Dashboard />} />
    <Route path="audit" element={<AuditPage />} />
    <Route path="tenants" element={<TenantList />} />
    <Route path="tenants/new" element={<CreateTenant />} />
    <Route path="tenants/:tenantId" element={<TenantBoundary />}>
      <Route index element={<TenantDetail />} />
      <Route path="analytics" element={<AnalyticsDashboard title="Tenant analytics" />} />
      <Route path="subscription" element={<Subscription />} />
      <Route path="authentication" element={<Authentication />} />
      <Route path="sso" element={<Sso />} />
      <Route path="tenant-admin" element={<TenantAdminTransfer />} />
    </Route>
    <Route path="*" element={<section className="ta-page"><h1>Platform page not found</h1><Link to="/platform-admin">Back to dashboard</Link></section>} />
  </Route>;
}
